<style scoped>
</style>

<template>
  <app-layout class="feed-single-page-template">
    <Row type="flex" justify="center">
      <Col :span="24">
        <iframe width="100%" height="650px" frameborder="0" :src="url" allowfullscreen></iframe>
      </Col>
    </Row>
  </app-layout>
</template>

<script>
export default {
  name: 'ReportMissingComponent',
  computed: {
    url: {
      get () {
        return (
          'https://www.ofwwatch.com/site/report/missing?sender_id=' +
          this.$store.state.user.info.id
        )
      }
    }
  }
}
</script>
